/**
 * WordPress Dependencies.
 */
import domReady from '@wordpress/dom-ready';
import { registerPlugin } from '@wordpress/plugins';
import { TextControl } from '@wordpress/components';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

import { __ } from '@wordpress/i18n';
import { useDispatch, useSelect } from '@wordpress/data';

domReady( () => {
	registerPlugin( 'coingate-token-address-picker', {
		render: () => {
			const metaKey = 'coingate-token-address';

			const currentTokenAddress = useSelect( ( select ) => {
				const postMeta = select( 'core/editor' ).getEditedPostAttribute(
					'meta'
				);
				return metaKey in postMeta ? postMeta[ metaKey ] : '';
			} );
			const { editPost } = useDispatch( 'core/editor' );

			const handleAddressChange = ( newAddress ) => {
				editPost( {
					meta: {
						[ metaKey ]: newAddress,
					},
				} );
			};

			return (
				<PluginDocumentSettingPanel
					icon={ () => null }
					title={ __( 'Token Address', 'web3-coin-gate' ) }
					name="wpcoingate-token-address-panel"
					className="wpcoingate-token-address-panel"
				>
					<TextControl
						label={ __( 'Address', 'web3-coin-gate' ) }
						onChange={ handleAddressChange }
						value={ currentTokenAddress }
						placeholder={ __(
							'Enter token address...',
							'web3-coin-gate'
						) }
						help={ __(
							'Enter the token address here.',
							'web3-coin-gate'
						) }
					/>
				</PluginDocumentSettingPanel>
			);
		},
	} );
} );
